export default "__VITE_ASSET__3fa8a8ef__"